import React, { useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleLoginButton from './GoogleLoginButton';
import { adminApi } from '../services/api';

const LoginScreen = ({ onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGoogleSuccess = async (googleToken) => {
    setLoading(true);
    setError('');

    try {
      const response = await adminApi.loginWithGoogle(googleToken);
      
      if (response.data.success) {
        // Store tokens
        localStorage.setItem('admin_access_token', response.data.tokens.accessToken);
        localStorage.setItem('admin_refresh_token', response.data.tokens.refreshToken);
        localStorage.setItem('admin_user', JSON.stringify(response.data.admin));
        
        // Call success callback
        onLoginSuccess(response.data.admin, response.data.tokens);
      } else {
        setError(response.data.message || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      let errorMessage = 'Erro de conexão. Tente novamente.';
      
      if (err.response?.data?.code === 'UNAUTHORIZED_EMAIL') {
        errorMessage = 'Este email não está autorizado para acesso administrativo. Entre em contato com o administrador do sistema.';
      } else if (err.response?.data?.code === 'EMAIL_NOT_VERIFIED') {
        errorMessage = 'Email não verificado com Google. Verifique sua conta Google.';
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleError = (error) => {
    console.error('Google login error:', error);
    setError('Erro ao fazer login com Google. Tente novamente.');
    setLoading(false);
  };

  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'your-google-client-id';

  const orgName = process.env.REACT_APP_ORG_NAME || 'ONG';

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <div className="login-container">
        <div className="login-background">
          <div className="login-overlay"></div>
        </div>

        <div className="login-modal">
          <div className="login-header">
            <div className="login-logo">
              <div className="logo-circle">
                <span className="logo-text">D</span>
              </div>
            </div>
            <h1 className="login-title">{orgName}</h1>
            <h2 className="login-subtitle">Painel Administrativo</h2>
            <p className="login-description">Sistema de Gestão de Rondas e Voluntários</p>
          </div>

          <div className="login-body">
            {error && (
              <div className="error-message">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                <span>{error}</span>
              </div>
            )}

            <div className="google-login-section">
              <div className="section-divider">
                <span>Iniciar Sessão</span>
              </div>

              <GoogleLoginButton
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleError}
                loading={loading}
              />
            </div>
          </div>

          <div className="login-footer">
            <div className="authorized-emails">
              <div className="footer-title">Acesso Restrito</div>
              <div className="footer-text">
                Apenas administradores autorizados podem aceder a este painel.
                Se necessita de acesso, contacte o administrador do sistema.
              </div>
            </div>

            <div className="footer-copyright">
              © {new Date().getFullYear()} {orgName}. Todos os direitos reservados.
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default LoginScreen;